"use strict";

exports.__esModule = true;
exports.default = void 0;
// Internal list of HTML entities for escaping.
var _default = exports.default = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#x27;',
  '`': '&#x60;'
};